import React from "react";
import { Helmet } from "react-helmet";

export default function PageHead({ evento }) {
  const eventoDescricao = evento.payload?.descricao;
  const titulo = eventoDescricao
    ? `${eventoDescricao} - Saltos Brasil – Confederação Brasileira de Saltos Ornamentais`
    : "Evento - Saltos Brasil – Confederação Brasileira de Saltos Ornamentais";

  return (
    <Helmet>
      <title>{titulo}</title>
      <meta name="description" content={titulo} />
    </Helmet>
  );
}
